module.exports = __webpack_public_path__ + "static/media/7.ce4e0803.jpg";